import mime from 'mime';

export type WebAppFileType = 'image' | 'video' | 'audio';

export function useUploadFile(
    config: {
        fileType?: WebAppFileType;
        extensions?: string[];
        maxFiles?: number;
    },
    onUpload: (files: File[]) => void
) {
    if (
        typeof window === 'undefined' ||
        typeof window.WebAppUploadChannel === 'undefined'
    ) {
        return null;
    }
    const id = Date.now() + Math.floor(Math.random() * 100);
    onMounted(() => {
        if (!window.HandleUpload) {
            window.HandleUpload = {};
        }
        window.HandleUpload[id] = files => {
            onUpload(
                files.map(({ base64, name }) => {
                    const byteCharacters = atob(base64);
                    const byteNumbers = new Array(byteCharacters.length);
                    for (let i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    const byteArray = new Uint8Array(byteNumbers);
                    const blob = new Blob([byteArray]);
                    const type =
                        mime.getType(name) || 'application/octet-stream';
                    return new File([blob], name, { type });
                })
            );
        };
    });
    onUnmounted(() => {
        if (!window.HandleUpload) {
            return;
        }
        window.HandleUpload[id] = undefined;
        if (Object.values(window.HandleUpload).every(value => !value)) {
            window.HandleUpload = undefined;
        }
    });
    return () =>
        window.WebAppUploadChannel?.postMessage(
            JSON.stringify({ ...config, id })
        );
}
